import { render, staticRenderFns } from "./Deco.vue?vue&type=template&id=2706d5bf&"
import script from "./Deco.vue?vue&type=script&lang=js&"
export * from "./Deco.vue?vue&type=script&lang=js&"
import style0 from "./Deco.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports